// extracted by mini-css-extract-plugin
export default {"filtersWrapper":"styles_filtersWrapper__pEigk","searchButton":"styles_searchButton__wnMj5","input":"styles_input__j26fm","tableWrapper":"styles_tableWrapper__ssdOg"};